import React, { useRef, useState, useLayoutEffect } from "react";

interface AutoSizeInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string;
  maxWidth?: number; // Maximum width in pixels
  minWidth?: number; // Optional minimum width
}

const AutoSizeInput: React.FC<AutoSizeInputProps> = ({ 
  value, 
  className, 
  style,
  maxWidth =200,
  minWidth = 20,
  ...props 
}) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const prevW = useRef<number>(0);
  const [pxWidth, setPxWidth] = useState<number | null>(null);
  const [animate, setAnimate] = useState(false);

  useLayoutEffect(() => {
  const span = spanRef.current;
  if (!span) return;


  span.textContent = value && value.length ? value : "\u00A0";

  let w = span.offsetWidth;

  if (w < minWidth) w = minWidth;
  if (w > maxWidth) w = maxWidth;

  setAnimate(prevW.current !== 0 && w < prevW.current);
  prevW.current = w;
  setPxWidth(w);
}, [value, maxWidth, minWidth]);


  const combinedStyle: React.CSSProperties = {
    padding: 0,
    boxSizing: "content-box",
    transition: animate ? "width 120ms ease-out" : "none",
    willChange: "width",
    width: pxWidth ? `${pxWidth}px` : undefined,
    maxWidth: `${maxWidth}px`,
    ...style,
  };

  return (
    <>
      <span
        ref={spanRef}
        aria-hidden
        className={className}
        style={{
          position: "absolute",
          left: -9999,
          top: -9999,
          visibility: "hidden",
          whiteSpace: "pre",
          font: "inherit",
          letterSpacing: "inherit",
          padding: 0,
          border: 0,
        }}
      />
      <input {...props} value={value} className={className} style={combinedStyle} />
    </>
  );
};

export { AutoSizeInput };
